import moment from 'moment'
import router from '../router/index'

export const utils = {
  methods: {
    async reloadUrl() {
      const to = router.currentRoute
      await router.replace('/pages/404')
      await router.replace(to)
    },
    isValidDateQuery(date) {
      console.log('isValidDateQuery', date)
      return moment(date, 'YYYY-MM-DD', true).isValid()
    },
    isValidQueryCreatedDate(query) {
      if (!query) return false
      if (!query.createdFrom) return false
      if (!query.createdTo) return false
      if (!this.isValidDateQuery(query.createdFrom)) return false
      if (!this.isValidDateQuery(query.createdTo)) return false
      return true
    },
    toBoolOrNull(value) {
      if (typeof value === 'boolean') return value
      if (value === 'true') return true
      if (value === 'false') return false
      return null
    },
    convertQueryString(searchOption) {
      if (!searchOption) return ''
      const purified = Object.entries(searchOption).reduce((a, [k, v]) => (v == null ? a : { ...a, [k]: v }), {})
      return new URLSearchParams(purified).toString()
    },
  }
}